'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _nestedtypes = require('nestedtypes');

var _auroraJavascriptUtils = require('@unitedtraders/aurora-javascript-utils');

var MoneyModel = _nestedtypes.Model.extend({
    defaults: {
        value: Number.value(0).has.check(function (value) {
            return !value || value >= 0;
        }, 'not negative'),
        currency: String.value('USD').has.check(_auroraJavascriptUtils.validator.notNull(), _auroraJavascriptUtils.validator.notNull().message)
    }
});

exports.default = MoneyModel;


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/statements-domain/dist/models/MoneyModel.js
// module id = 740
// module chunks = 118